export class PaiIncidentRow{
  InquiryID: number
  RowID: number
  RowType: number
  TextLOC: string
  TextENG: string
  Attachments: number
  DMSAttachmentID: number
  RecordingDate: Date
  TBCreated: Date
}

export class PaiIncident{
  InquiryID: number
  ProductCode: string
  ReleaseNr: string
  RecordingDate: Date
  FunctionalAreas: string
  FunctionalAreasENG: string;
  DescriptionLOC: string
  DescriptionENG: string
  ProductDescription: string
  InquiryRows: PaiIncidentRow[]
}

export enum RowType{
  Domanda = 41746432,
  Risposta = 41746433
}